/**
 * EmptyCampaignState
 *
 * Empty state card for campaigns list with optional premium banner and
 * permission-aware create CTA.
 */
import React from 'react';
import { Video, Plus, Shield } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function EmptyCampaignState({ onNewCampaign, hasReadOnlyPermission = false, showPremiumBanner = false }) {
  const navigate = useNavigate();

  const handleUpgrade = () => {
    navigate('/app/account', { 
      state: { 
        fromFeature: true, 
        returnPath: '/app/campaigns', 
        featureName: 'Campaign Creation' 
      } 
    });
  };

  return (
    <div className="bg-white dark:bg-gray-900 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm p-6 mb-8">
      <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
        <Video className="w-16 h-16 text-gray-400 mb-4" />
        
        <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2">
          No Campaigns Yet
        </h3>
        
        <p className="text-gray-600 dark:text-gray-400 mb-6 max-w-md">
          Create your first supporter video campaign to start collecting powerful stories from your community.
        </p>
        
        {showPremiumBanner && (
          <div className="mb-6 w-full max-w-md rounded-lg bg-purple-50 dark:bg-purple-900/20 p-4 border border-purple-200 dark:border-purple-800/50">
            <p className="text-sm text-purple-800 dark:text-purple-300">
              Campaign creation is a premium feature. Upgrade to create and manage multiple campaigns.
            </p>
          </div>
        )}
        
        <button
          onClick={hasReadOnlyPermission ? undefined : onNewCampaign}
          disabled={hasReadOnlyPermission}
          className={`px-4 py-2 rounded-md transition-colors inline-flex items-center gap-2 ${
            hasReadOnlyPermission 
              ? 'bg-gray-300 cursor-not-allowed dark:bg-gray-700/50 text-gray-600 dark:text-gray-400' 
              : 'bg-primary-600 text-white hover:bg-primary-700'
          }`}
          title={hasReadOnlyPermission ? "You have read-only access in this namespace" : "Create a new campaign"}
        >
          {hasReadOnlyPermission && <Shield className="h-4 w-4" />}
          <Plus className="h-4 w-4" />
          Create Campaign
        </button>
      </div>
    </div>
  );
} 